import React from 'react';
import classNames from 'classnames';
import css from './Map.css';
import { StaticMap } from './GoogleMap';

const StaticMapPreviewContainer = ({
    onActivate,
    onKeyDown,
    ariaLabel = 'Klicken Sie hier, um die interaktive Karte zu öffnen.',
    zoom,
    address = '',
    forceFuzzy = false,
    mapsConfig,
    center,
    rootClassName = '',
}) => (
    <div
        className={classNames(css.root, css.staticMapRoot)}
        onClick={onActivate}
        onKeyDown={onKeyDown}
        role="button"
        tabIndex={0}
        aria-label={ariaLabel}
    >
        <div className={classNames(css.mapRoot, rootClassName)}>
            <StaticMap
                center={center}
                zoom={zoom}
                address={address}
                mapsConfig={mapsConfig}
                forceFuzzy={forceFuzzy}
            />
        </div>
    </div>
);

export default StaticMapPreviewContainer;
